var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaven(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill:url(#SVGID_3_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n\t.st5{fill:url(#SVGID_5_);}\r\n\t.st6{fill:url(#SVGID_6_);}\r\n\t.st7{fill:url(#SVGID_7_);}\r\n\t.st8{fill:url(#SVGID_8_);}\r\n\t.st9{fill:url(#SVGID_9_);}\r\n\t.st10{fill:url(#SVGID_10_);}\r\n\t.st11{fill:url(#SVGID_11_);}\r\n\t.st12{fill:url(#SVGID_12_);}\r\n\t.st13{fill:url(#SVGID_13_);}\r\n\t.st14{fill:url(#SVGID_14_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(250.163459, 25.431550)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -264.2791,
    y1: 65.4728,
    x2: -263.6096,
    y2: 65.7057,
    gradientTransform: "matrix(14.6137 0 0 -15.5901 3656.0044 1014.9252)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F69923"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3123,
    style: {
      stopColor: "#F79A23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8383,
    style: {
      stopColor: "#E97826"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-206.6-9.3c-0.1,0.2-0.2,0.5-0.3,0.9l-0.1,0.3c0,0.1,0,0.2-0.1,0.3l-0.1,0.3l0,0l-0.1,0.4l0,0l-0.1,0.4l0,0 l0,0.4l0,0l0,0.4l0,0l0,0.4c0,0.1,0,0.1,0,0.2l0,0.5l0,0l0,0.5l0,0l0,0.5c0,0.1,0,0.2,0,0.3l3.1,1.5c0-1.8,0-3.5,0.2-5l0-0.3l0,0 l0,0.3l0,0l0,0.4l0,0l0,0.2l0,0l0,0.5l0,0l0,0.3l0,0l0,0.6l0,0l0,0.5l0,0l0,0.5l0,0l0,0.4l0,0l0,0.6l0,0l0,0.4l0,0l0,0.4 c0,0.1,0,0.2,0,0.2c0.6-0.5,1.3-1.1,2-1.7l0.5-0.5c0.1-0.1,0.2-0.2,0.2-0.2l0.5-0.5l0,0l0.5-0.5l0,0l0.5-0.5l0,0l0.4-0.5l0,0 c-0.5-1-1-1.7-1.5-2.3l-0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3l-0.2-0.1l0,0l-0.1-0.1c0,0-0.1-0.1-0.1-0.1l-0.1-0.1l0,0l-0.1-0.1l0,0 l-0.2-0.1l0,0l-0.2-0.1l0,0l-0.2-0.1l0,0l-0.1-0.1l0,0l-0.2-0.1l0,0l-0.2-0.1l0,0l-0.2,0l0,0l-0.1,0l0,0l-0.1,0c0,0,0,0-0.1,0 l-0.2,0l0,0l-0.2,0C-205.1-10.5-206.2-10.4-206.6-9.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-198.6,27.7l-0.4-1.6l0,0l-0.4-1.4l0,0l-0.2-0.6l0,0l-0.3-1.2l0,0l-0.3-1.2l0,0l-0.3-1.2 c0-0.2-0.1-0.4-0.1-0.6l-0.3-1.2l0,0l-0.3-1.2c-0.1-0.6-0.3-1.2-0.4-1.7l-0.2-1.1c0-0.2-0.1-0.4-0.1-0.6l-0.2-0.8l0,0l-0.4-1.9 l0,0l-0.1-0.4l0,0l-0.2-0.8l0,0l0-0.3l0,0l0-0.2l0,0l-0.1,0.1l-0.3-0.2l0,0.1l0,0c0.1,0.4,0.1,0.8,0.2,1.2l0.2,1.3 c0,0.1,0,0.2,0.1,0.4c0.1,0.7,0.3,1.5,0.4,2.2l0.2,0.7c0.2,1,0.4,2,0.7,3c0.2,1,0.5,2,0.7,2.9c0.2,0.6,0.3,1.3,0.5,1.9l0.2,1 c0.3,1,0.5,2,0.8,2.9c0.1,0.2,0.1,0.4,0.2,0.7l0.3,1.2c0.1,0.4,0.2,0.8,0.3,1.1l0.5,0.2l0.2-0.1c0,0,0,0,0-0.1 C-198,29.6-198.3,28.6-198.6,27.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -275.2378,
    y1: 63.6362,
    x2: -275.0696,
    y2: 65.6689,
    gradientTransform: "matrix(8.2401 0 0 -25.0913 2061.3752 1645.9784)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3233,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6302,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7514,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-203.6,6.9c-0.1-1-0.3-2-0.4-3c-0.1-0.8-0.2-1.6-0.2-2.4l-0.1-0.7c0,0,0,0,0-0.1c-0.1-1-0.1-1.9-0.1-2.8 l-3.1-1.5l0,0.2l0,0l0,0.4l0,0c0,0.7-0.1,1.5-0.1,2.3c0,0.9,0,1.9,0,2.9c0,0.9,0.1,1.9,0.1,2.9c0,0.6,0.1,1.3,0.1,1.9l0.1,0.7l0,0 l4.1,2.1l-0.1-1l0,0L-203.6,6.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -270.3638,
    y1: 65.8407,
    x2: -270.1975,
    y2: 67.5928,
    gradientTransform: "matrix(10.6027 0 0 -22.9403 2670.9114 1558.1509)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282662"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09548389,
    style: {
      stopColor: "#662E8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7882,
    style: {
      stopColor: "#9F2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9487,
    style: {
      stopColor: "#CD2032"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-197.7,30.6l0.1,0.2l0,0l0.4,1.4c0.1,0.2,0.1,0.4,0.2,0.6l0.2,0.6l0,0l0.1,0.2c0,0,0,0.1,0,0.1l0.7,2.1l0,0 c0.6-0.1,1.3,0.1,2,0.4l0.3,0.1l0,0c-0.6-0.7-1.3-1.1-2.2-1.2c2.5-1.7,4.1-3.8,3.9-6.4c0-0.2-0.1-0.5-0.1-0.7 c0,0.9-0.4,1.6-1.5,2.4l-0.1,0.1l0,0c1.1-2,1.4-3.3,1.3-5.1c0-0.4-0.1-0.9-0.2-1.3c-0.4,2.6-1.8,4.3-3.8,5.3L-197.7,30.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -262.4657,
    y1: 64.7859,
    x2: -262.282,
    y2: 65.9318,
    gradientTransform: "matrix(16.6758 0 0 -42.7786 4172.2969 2818.0803)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3233,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6302,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7514,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-199.2,27.6l-0.3-1l0,0l-0.5-2l0,0c-0.2-1-0.5-1.9-0.7-2.9s-0.5-2-0.7-2.9c-0.2-1-0.5-2-0.7-3l-0.2-1l0,0 l-0.4-2l0,0c-0.1-0.4-0.1-0.7-0.2-1.1c-0.1-0.6-0.2-1.2-0.3-1.8l0-0.1l0,0l-4.1-2.1l0,0.1c0,0,0,0,0,0.1c0.1,0.9,0.2,1.9,0.3,2.8 c0.1,1,0.2,1.9,0.4,2.9c0.1,0.8,0.2,1.6,0.4,2.4l0.1,0.5l0,0c0.2,1,0.4,2,0.6,2.9c0.2,1,0.5,2,0.8,2.9c0.2,0.6,0.3,1.2,0.5,1.7 l0.2,0.5l0,0l0.3,0.9l0,0c0.4,1.1,0.8,2.1,1.3,3.1l4.1,2.1c-0.2-0.8-0.4-1.5-0.6-2.3l-0.1-0.4l0,0L-199.2,27.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -260.2944,
    y1: 65.783,
    x2: -260.0302,
    y2: 66.4161,
    gradientTransform: "matrix(20.4072 0 0 -39.2476 5112.646 2627.1865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282662"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09548389,
    style: {
      stopColor: "#662E8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7882,
    style: {
      stopColor: "#9F2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9487,
    style: {
      stopColor: "#CD2032"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-202.4,28.6c0.5,1.1,1,2.1,1.6,3.1l0.3,0.5l0,0c-0.4-0.2-0.9-0.2-1.4-0.3l-0.2,0c0,0-0.1,0-0.1,0l-0.2,0l0,0 l-0.3,0l0,0l-0.3,0l0,0l-0.2,0l0,0l-0.3,0c0,0,0,0,0,0c2.1,0.7,3.9,1.6,5,2.9c-0.5,0.5-1.3,0.9-2.4,1.2c0.8,0.1,1.4,0.1,1.8,0 l0.2,0c0,0,0.1,0,0.1,0l0.1,0l0,0l0.1,0l0,0l0.2-0.1l0,0l0.1,0l0,0c-0.7,0.5-1.1,1.5-1.4,2.5l-0.1,0.4c0,0.1,0,0.1-0.1,0.2 c0.9-1.4,1.7-2.4,2.6-2.7c0.9,3.1,2,6.4,3.2,9.9l0.6,1.6c0.2,0.5,0.4,1.1,0.6,1.6c0.3-0.4,0.3-0.8,0.2-1.2l-0.4-1.1l0,0l-0.4-1.3 l0,0l-0.7-2l0,0l-0.6-1.7l0,0l-0.6-1.9l0,0l-0.6-1.8l0,0l-0.5-1.7l0,0l-0.4-1.3l0,0l-0.3-1.1l0,0c0-0.1-0.1-0.3-0.1-0.4l-0.1-0.4 l0,0l-0.3-1.2l0,0l-0.4-1.2l0,0l-0.2-0.6l0,0l0,0l0,0l-4.1-2.1C-202.5,28.5-202.5,28.5-202.4,28.6L-202.4,28.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -262.128,
    y1: 64.5339,
    x2: -262.0349,
    y2: 65.8067,
    gradientTransform: "matrix(17.3983 0 0 -50.2471 4361.4917 3296.7444)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3233,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6302,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7514,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-202.7,9.9l0.1,0.4l0,0c0.1,0.3,0.1,0.5,0.2,0.8l0.4,2.3l0,0l0.2,0.8l0,0l0.2,1.1c0,0.2,0.1,0.4,0.1,0.6 c0.1,0.6,0.3,1.1,0.4,1.7l0.3,1.2l0,0l0.3,1.2c0,0.2,0.1,0.4,0.1,0.6l0.3,1.2l0,0l0.3,1.2c0.2,0.6,0.3,1.2,0.5,1.8 c0.1,0.5,0.2,0.9,0.4,1.4l0.4,1.6l0,0l0.3,1.1l0,0l0.3,1.2c0.1,0.2,0.1,0.4,0.2,0.6c0,0,0,0,0,0.1l1.2-1.1l0,0l0,0l-0.1,0l0,0 c1.5-1.4,2.7-4.2,3-6.7c0.1-1.2,0.1-2.4,0-3.7c-0.1-1-0.3-2-0.6-3.2c-0.2-1-0.5-2-0.9-3.1c-0.2,0.5-0.5,0.9-0.9,1.4l-0.2,0.2l0,0 l-0.1,0.1l0,0l-0.2,0.2l0,0c1.1-1.7,1.2-3.5,0.9-5.4c-0.2,0.6-0.6,1.4-1.2,2.1c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0,0,0,0l0,0 c0.4-0.6,0.6-1.2,0.8-1.7c0-0.1,0-0.2,0.1-0.2l0-0.1c0-0.2,0.1-0.4,0.1-0.6l0-0.4l0,0c0-0.2,0-0.4,0-0.7l0-0.4c0,0,0-0.1,0-0.1 l0-0.3c0,0,0-0.1,0-0.1c-0.1-0.5-0.2-0.9-0.3-1.3l-0.1-0.3l0,0l-0.1-0.3l0,0l-0.1-0.3l0,0l-0.1-0.4c0,0,0-0.1,0-0.1l-0.1-0.2 c0-0.1-0.1-0.1-0.1-0.2l-0.1-0.1c0,0.1,0,0.1-0.1,0.2l0,0.1c-0.3,0.6-0.9,1.4-1.4,2c0,0,0,0,0,0l-0.1,0.1c0,0,0,0-0.1,0.1l0,0l0,0 L-202.7,9.9C-202.7,9.8-202.7,9.9-202.7,9.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -267.6335,
    y1: 63.0574,
    x2: -267.4722,
    y2: 65.4501,
    gradientTransform: "matrix(11.973 0 0 -30.5111 3001.5103 1993.2666)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3233,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6302,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7514,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-204.2-2.2c0,0.3,0,0.6,0.1,0.9l0,0.6c0,0.1,0,0.2,0,0.3l0.1,0.7c0,0.1,0,0.2,0,0.4l0,0.1c0,0,0,0,0,0.1 c0,0.3,0.1,0.7,0.1,1.1l0.1,0.8c0,0.3,0.1,0.5,0.1,0.8l0.2,1.2c0.1,0.6,0.2,1.1,0.2,1.7l0.1,0.5c0.1,0.5,0.1,0.9,0.2,1.4l0.3,1.5 l0,0l3.9-3.6c0.8-1.5,1-2.4,1-3.5c0-0.2,0-0.5,0-0.7l0-0.2c-0.1-1-0.2-2.1-0.4-3.1c-0.2-1-0.4-1.9-0.6-2.8c-0.1-0.5-0.3-1-0.4-1.4 c-0.1-0.3-0.3-0.7-0.4-1l-0.4,0.5c-0.1,0.1-0.2,0.2-0.2,0.2l-0.5,0.5l0,0l-0.5,0.5l0,0l-0.5,0.5c-0.1,0.1-0.2,0.2-0.2,0.2 l-0.5,0.4C-203.1-3.1-203.7-2.6-204.2-2.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260.140093, 28.696875)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -273.9663,
    y1: 62.2942,
    x2: -273.2043,
    y2: 62.4713,
    gradientTransform: "matrix(17.1597 0 0 -14.9626 4520.9214 925.2357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F69923"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3123,
    style: {
      stopColor: "#F79A23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8383,
    style: {
      stopColor: "#E97826"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-176.7-11.8c-0.1,0.1-0.3,0.1-0.4,0.2l-0.2,0.1c-0.2,0.1-0.3,0.2-0.5,0.3l-0.3,0.2l0,0l-0.3,0.2l0,0 l-0.3,0.2l0,0l-0.3,0.2c-0.1,0-0.1,0.1-0.2,0.1l-0.3,0.3l0,0l-0.3,0.3l0,0l-0.4,0.3l0,0l-0.4,0.3l0,0l-0.4,0.3l0,0l-0.4,0.3l0,0 l-0.4,0.4c-0.1,0.1-0.1,0.1-0.2,0.2l1.3,3.6c1.4-1.5,2.8-2.8,4.2-3.9l0.5-0.4l0,0l0,0l0,0l-0.3,0.3l0,0l-0.3,0.3l0,0l-0.4,0.3l0,0 l-0.3,0.3l0,0l-0.3,0.3l0,0l-0.2,0.2l0,0l-0.4,0.4l0,0l-0.4,0.4l0,0l-0.5,0.5l0,0l-0.3,0.3l0,0l-0.3,0.3l0,0l-0.4,0.5l0,0 l-0.3,0.4l0,0c0.3,0,0.7,0.1,1,0.1l0.6,0l0,0l0.6,0l0,0l0.6,0l0,0l0.6,0l0,0l0.7,0c0.1,0,0.2,0,0.3,0l0.7,0c0.1,0,0.2,0,0.3,0 l0.6,0c0.1,0,0.2,0,0.3,0l0.6,0l0,0c0.5-1.5,0.6-2.8,0.6-3.7l0-0.2l0,0l0-0.2c0,0,0-0.1,0-0.1l0-0.2l0,0l0-0.2c0,0,0-0.1,0-0.1 l0-0.2l0,0l0-0.1l0,0l0-0.1l0,0l0-0.1l0,0l-0.1-0.2l0,0l-0.1-0.1l0,0l-0.1-0.3l0,0l-0.1-0.1l0,0l-0.1-0.1l0,0l-0.1-0.1l0,0 l-0.1-0.1l0,0l-0.1-0.1l0,0l-0.1-0.1C-174.3-11.4-175.3-12.3-176.7-11.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-200.1,25.3l0.5-1l0,0l0.7-1.3l0,0l0.6-1.1c0.1-0.2,0.2-0.4,0.3-0.6l0.7-1.2l0,0l0.7-1.2 c0.1-0.2,0.2-0.4,0.3-0.6c0.4-0.6,0.7-1.2,1.1-1.8l0.7-1.2l0,0c0.6-1,1.2-2,1.8-2.9l0.7-1.1c0.1-0.2,0.2-0.4,0.3-0.5l0.5-0.8l0,0 l0.6-0.9l0,0l0.6-0.9l0,0l0.3-0.4l0,0l0.5-0.8l0,0l0.1-0.1l0,0l0.2-0.2c0,0,0,0,0-0.1l-0.2,0l-0.1-0.4l-0.1,0.1l0,0 c-0.3,0.4-0.5,0.8-0.8,1.2l-0.9,1.3c-0.1,0.1-0.2,0.2-0.2,0.3c-0.5,0.7-1,1.4-1.4,2.2l-0.5,0.7c-0.6,1-1.3,2-1.9,2.9 c-0.6,1-1.2,1.9-1.8,2.9c-0.4,0.6-0.8,1.3-1.1,1.9l-0.6,1c-0.6,1-1.2,2-1.7,3c-0.1,0.2-0.3,0.4-0.4,0.7c-0.5,0.8-0.9,1.6-1.3,2.4 l0.2,0.6l0.2,0c0,0,0,0,0-0.1C-200.8,26.7-200.4,26-200.1,25.3L-200.1,25.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -272.8027,
    y1: 60.2997,
    x2: -272.0131,
    y2: 62.3325,
    gradientTransform: "matrix(18.9367 0 0 -26.6104 4966.6528 1652.738)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3233,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6302,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7514,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M-187.1,3.6c0.7-0.9,1.4-1.8,2.1-2.7c0.7-0.9,1.4-1.8,2.2-2.7c0-0.1,0.1-0.1,0.1-0.1c0.7-0.8,1.4-1.6,2.1-2.4 l-1.3-3.6l-0.2,0.1l0,0l-0.3,0.3l0,0c-0.6,0.6-1.2,1.2-1.9,1.8c-0.4,0.4-0.7,0.7-1.1,1.1l-0.8,0.8c-0.1,0.1-0.3,0.3-0.4,0.4 c-0.7,0.8-1.5,1.6-2.2,2.4c-0.5,0.5-0.9,1.1-1.4,1.6l-0.5,0.6l0,0l1.6,4.9l0.6-0.9l0,0L-187.1,3.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -270.0004,
    y1: 63.8646,
    x2: -269.222,
    y2: 64.8401,
    gradientTransform: "matrix(22.5754 0 0 -16.8448 5888.0874 1113.2291)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282662"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09548389,
    style: {
      stopColor: "#662E8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7882,
    style: {
      stopColor: "#9F2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9487,
    style: {
      stopColor: "#CD2032"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M-201.2,27.4l-0.2,0.5l0,0l-0.6,1.2c-0.1,0.2-0.2,0.4-0.3,0.6l-0.3,0.7l0,0c-0.1,0.1-0.1,0.2-0.2,0.4 l-0.4,0.7l0,0l-0.8,1.5l0,0c0.6,0.4,1.1,1.3,1.4,2.3c0.1-1-0.2-1.9-0.8-2.7c3.3,0.6,6.4,0.2,8.2-2c0.2-0.2,0.3-0.4,0.5-0.6 c-0.8,0.7-1.6,1-3.1,0.7l-0.2,0l0,0c2.5-0.7,3.8-1.5,5.1-3.1c0.3-0.4,0.6-0.8,0.9-1.2c-2.4,1.8-4.8,2-7.2,1.2L-201.2,27.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -268.3288,
    y1: 61.3991,
    x2: -267.9497,
    y2: 62.545,
    gradientTransform: "matrix(26.7037 0 0 -47.6867 6963.5068 2972.751)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3233,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6302,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7514,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M-200.1,24l0.7-1.2l0,0l1.1-2l0,0c0.6-1,1.1-1.9,1.7-2.9s1.2-1.9,1.8-2.9c0.6-1,1.2-2,1.9-2.9 c0.6-1,1.3-1.9,1.9-2.9c0.2-0.3,0.5-0.7,0.7-1c0.4-0.6,0.8-1.2,1.2-1.7l0.1-0.1l0,0l-1.6-4.9l-0.1,0.1c0,0,0,0-0.1,0.1 c-0.7,0.8-1.3,1.6-2,2.5c-0.7,0.9-1.3,1.7-2,2.6c-0.5,0.8-1.1,1.5-1.6,2.3l-0.3,0.5l0,0c-0.7,1-1.3,1.9-1.8,2.8 c-0.6,1-1.2,2-1.7,2.9c-0.3,0.6-0.6,1.2-0.9,1.8c-0.2,0.5-0.5,1-0.7,1.5c-0.5,1.2-1,2.3-1.4,3.5l1.7,4.9l0.3-0.6l0,0l0.7-1.2 c0.1-0.2,0.2-0.4,0.3-0.6L-200.1,24L-200.1,24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -270.5554,
    y1: 62.2994,
    x2: -270.3701,
    y2: 62.9325,
    gradientTransform: "matrix(19.9264 0 0 -45.762 5183.6479 2892.2327)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#282662"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09548389,
    style: {
      stopColor: "#662E8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7882,
    style: {
      stopColor: "#9F2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9487,
    style: {
      stopColor: "#CD2032"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M-203.3,22.1c-0.4,1.2-0.8,2.5-1.1,3.8l-0.2,0.7l0,0c-0.1-0.3-0.4-0.7-0.7-1l-0.2-0.2c0,0-0.1-0.1-0.1-0.1 l-0.2-0.2l0,0l-0.2-0.2l0,0l-0.2-0.2l0,0l-0.2-0.2l0,0l-0.2-0.2l0,0l-0.2-0.2l0,0l-0.2-0.2l0,0c1.1,2.2,1.9,4.4,1.7,6.4 c-0.8,0-1.8-0.3-2.9-0.9c0.5,0.6,0.9,1,1.3,1.3l0.2,0.1c0,0,0.1,0,0.1,0.1l0.2,0.1l0,0l0.1,0.1l0,0l0.1,0.1l0,0l0.1,0.1l0,0l0.1,0 l0,0l0.1,0c0,0,0,0,0,0c-0.9-0.1-2,0.3-3,0.9l-0.4,0.2l0,0l-0.4,0.2l0,0c1.8-0.5,3.3-0.5,4.3-0.1c-0.5,0.9-1,1.8-1.4,2.8l-0.7,1.4 c-1.1,2.2-2.2,4.4-3.3,6.7l-0.7,1.6c-0.2,0.5-0.5,1.1-0.7,1.6c0.5-0.1,0.8-0.4,1.1-0.8l0.8-1.8l0,0l0.8-1.6l0,0l1-2l0,0l0.9-1.8 l0,0l0.9-1.7l0,0l0.8-1.6l0,0l1.1-2.2l0,0l0.8-1.5l0,0l0.3-0.5l0,0l0.2-0.4l0,0l0.2-0.4l0,0l0.3-0.6l0,0l0.7-1.3 c0.1-0.2,0.2-0.4,0.3-0.6l0.3-0.6l0,0l0,0l0,0l-1.7-4.9C-203.3,21.9-203.3,22-203.3,22.1L-203.3,22.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -265.7776,
    y1: 61.549,
    x2: -265.001,
    y2: 62.7655,
    gradientTransform: "matrix(40.7082 0 0 -39.7966 10610.585 2494.2332)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3233,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6302,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7514,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M-188.7,6.8l-0.3,0.4l0,0c-0.2,0.3-0.4,0.5-0.5,0.8l-0.8,1.3l0,0l-0.6,0.9l0,0l-0.2,0.2 c-0.2,0.4-0.5,0.7-0.7,1.1l-0.7,1.1l0,0c-0.5,0.7-0.9,1.5-1.4,2.3l-0.4,0.6c-0.6,0.9-1.2,1.9-1.8,3l-0.7,1.2 c-0.3,0.6-0.7,1.2-1.1,1.8c-0.2,0.4-0.4,0.7-0.6,1.1l-1.1,1.9l0,0l-0.3,0.6l0,0l-0.7,1.2c-0.2,0.4-0.4,0.8-0.7,1.2c0,0,0,0,0,0.1 l1.9,0.1c0,0-0.1,0-0.1,0c2.3,0.1,5.5-1.2,7.7-3c1-0.8,2-1.8,2.9-3c0.7-0.9,1.4-1.9,2-3c0.6-1,1.2-2.1,1.7-3.2 c-0.6,0.2-1.2,0.3-1.8,0.3l-0.4,0l0,0c-0.1,0-0.2,0-0.2,0l-0.1,0l0,0c2.2-0.5,3.8-1.8,5-3.6c-0.6,0.3-1.6,0.6-2.7,0.7 c-0.1,0-0.3,0-0.5,0c0,0,0,0-0.1,0l0,0c0.8-0.2,1.4-0.4,2-0.8c0.1,0,0.2-0.1,0.2-0.1l0.1-0.1c0.2-0.1,0.4-0.2,0.5-0.4l0.3-0.3l0,0 c0.2-0.2,0.5-0.5,0.7-0.7l0.1-0.2c0,0,0-0.1,0.1-0.1l0.2-0.2c0,0,0.1-0.1,0.1-0.1c0.3-0.5,0.6-0.9,0.8-1.3l0.1-0.2 c0.1-0.2,0.2-0.4,0.3-0.6l0.1-0.2l0,0l0.2-0.4c0-0.1,0.1-0.1,0.1-0.2l0.1-0.1l0,0l0.1-0.2c0-0.1,0-0.1,0.1-0.2l0-0.1 c-0.1,0-0.1,0.1-0.2,0.1l-0.1,0c-0.7,0.3-1.8,0.5-2.7,0.5c0,0,0,0,0,0l-0.2,0c0,0-0.1,0-0.1,0l0,0l0,0L-188.7,6.8 C-188.7,6.7-188.7,6.7-188.7,6.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -268.9215,
    y1: 61.3141,
    x2: -267.8741,
    y2: 62.5596,
    gradientTransform: "matrix(28.8072 0 0 -20.7843 7538.1104 1299.6587)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3233,
    style: {
      stopColor: "#9E2064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6302,
    style: {
      stopColor: "#C92037"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7514,
    style: {
      stopColor: "#CD2335"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E97826"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M-180.4-4.2c-0.2,0.2-0.4,0.5-0.7,0.8l-0.5,0.5l0,0l-0.5,0.6l0,0l-0.6,0.7c0,0,0,0,0,0.1 c-0.3,0.4-0.7,0.8-1,1.3l-0.5,0.7c-0.1,0.1-0.2,0.2-0.3,0.4l-0.8,1l0,0l-0.5,0.7c-0.3,0.3-0.5,0.7-0.8,1.1l-0.3,0.4 c-0.3,0.4-0.5,0.7-0.8,1.1l-0.6,0.8l0,0l-0.6,0.8l0,0l6,0.2c1.8-0.5,2.7-1.1,3.6-2.1c0.2-0.2,0.4-0.4,0.5-0.6l0.2-0.2 c0.7-0.9,1.5-1.8,2.2-2.8c0.7-0.9,1.3-1.8,1.7-2.7c0.3-0.5,0.6-1,0.8-1.5c0.2-0.4,0.3-0.8,0.4-1.1l-0.6,0l0,0l-0.6,0l0,0l-0.6,0 l0,0l-0.7,0c-0.1,0-0.2,0-0.3,0l-0.7,0l0,0l-0.6,0c-0.1,0-0.2,0-0.3,0l-0.6,0c-0.1,0-0.2,0-0.3,0l-0.6,0 C-179.7-4.1-180-4.1-180.4-4.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaven);
export default __webpack_public_path__ + "static/media/Maven.4f2e6a20d192794bfd3e7949a8bbc57e.svg";
export { ForwardRef as ReactComponent };